import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Config } from '../helpers/Config';


const LanguageContext = React.createContext();

let langFile = Config.appSettings.defaultLanguageFile;

class LanguageProvider extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            language: Config.appSettings.defaultLanguage
        }
        this.changeLanguage = this.changeLanguage.bind(this)
    }
    componentDidMount() {
        let lang = localStorage.getItem('lang') || this.state.language;
        this.setLanguage(lang);
    }
    changeLanguage(event, lang) {
        this.setLanguage(lang);
        event.preventDefault();
    }
    setLanguage(lang) {

        this.setState({ language: lang });
        localStorage.setItem('lang', lang);

        try {
            langFile = require('../assets/lang/' + lang);
        } catch (e) {
            langFile = require('../assets/lang/' + Config.appSettings.defaultLanguage);
        }
    }
    render() {
        return (
            <LanguageContext.Provider
                value={{
                    language: this.state.language,
                    changeLanguage: this.changeLanguage
                }}
            >
                {this.props.children}
            </LanguageContext.Provider>
        )
    }
}

const LanguageConsumer = LanguageContext.Consumer;

const Translate = (text) => {
    return (ReactHtmlParser(langFile[text] || SetLanguageFile(text)))
}

const TranslateExt = (text) => (
    <LanguageConsumer>
        {() => (Translate(text))}
    </LanguageConsumer>
)

//TODO: yayına alınmadan önce kaldırılacak.
const SetLanguageFile = (text) => {

    let languageFile = (JSON.parse(localStorage.getItem("languageFile")) || {});
    languageFile["\"" + text + "\""] = text;

    try {
        localStorage.setItem("languageFile", JSON.stringify(languageFile));
    } catch (error) {
        
    }

    return text;
}



export { LanguageProvider, LanguageConsumer, Translate, TranslateExt }